import { CommonModule } from '@angular/common';
import { Component, HostListener, Injectable, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgImageSliderModule } from 'ng-image-slider';
import { zip } from 'rxjs';
import { CacheService } from '../../../services/cache.service';
import { FeatureAccessService } from '../../../services/framework/featureaccess.service';
import { ApplicationItem } from '../applications/models/applicationItem';
import { ApplicationsService } from '../applications/services/application.service';
import { IPinnedTile, TileService } from '../widgets/services/tile.service';
import { Tile } from '../widgets/tile/tile.component';

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-quicklinks',
  standalone: true,
  templateUrl: './quicklinks.component.html',
  styleUrls: ['./quicklinks.component.scss'],
  imports: [
    CommonModule
    , NgImageSliderModule,
    FormsModule
  ]
})
export class QuicklinksComponent implements OnInit {
  pinnedTiles: IPinnedTile[] = [];
  appsItem: ApplicationItem[] = [];
  tilesApplications: Tile[] = [];
  tiles: Tile[] = [];
  actualAplication!: ApplicationItem;
  actualapplications: ApplicationItem[] = [];
  currentIndex = 0;
  sliderstyle: any = {
    width: 'auto',
    height: 100,
    space: 5
  };
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // Reset and recalculate image sizes on window resize
    this.count = 0;
    setTimeout(() => {
      this.setImageSize();
    }, 200);
  }

  singleaAplication!: ApplicationItem;
  @Input() applications: ApplicationItem[] = [];
  @Input() applicationsMain: ApplicationItem[] = [];
  @Input() applicationsDD: ApplicationItem[] = [];
  imageObject!: ImageObject;
  imageObjects: ImageObject[] = [];
  images: any;


  constructor(private appService: ApplicationsService, private cache: CacheService, private router: Router, private route: ActivatedRoute, private tiliesService: TileService, private featureaccess: FeatureAccessService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.getPinnedData();
    }, 3000)
  }
  ngAfterViewInit() {
    this.setImageSize();
  }
  count: number = 0;

  setImageSize() {
    var myVar = setInterval(() => {
      if (document.querySelectorAll('.image').length > 0) {
        this.count += 1;
        if (this.count > 0) {
          clearInterval(myVar);
        }
        this.images = document.querySelectorAll('.image');

        if (this.images.length > 0) {
          var customImg = document.getElementsByTagName('custom-img')[0] as HTMLElement;
          var mngSliderDivs = document.querySelectorAll('.mng-slider>div');
          var containElem = document.querySelector('.contain') as HTMLElement;

          var imageContainerWidth = customImg ? customImg.offsetWidth : 0;
          var sliderWidth = (mngSliderDivs.length > 1 && mngSliderDivs[1]) ? mngSliderDivs[1].clientWidth : 0;
          var containerWidth = containElem ? containElem.clientWidth : 990;
          var noOfTileInSlider = Math.floor(containerWidth / 110); // Approximate width per item

          // Always show navigation arrows for better UX
          var navButtons = document.getElementsByClassName('prev');
          if (navButtons.length > 0) {
            (navButtons[0] as HTMLElement).style.display = 'block';
          }

          navButtons = document.getElementsByClassName('next');
          if (navButtons.length > 0) {
            (navButtons[0] as HTMLElement).style.display = 'block';
          }

          for (var i = 0; i < this.images.length; i++) {
            (this.images[i] as HTMLElement).setAttribute("style", "");
            (this.images[i] as HTMLElement).setAttribute("style", "width:auto;max-width:100px;max-height:40px;");
          }
        }
      }
    }, 100);
  }
  delay(time: number) {
    return new Promise(resolve => setTimeout(resolve, time));
  }
  retrieveApplications(): void {
    this.appService.getAllItems()
      .subscribe(
        data => {
          this.applications = data;
          this.loadItems();
        },
        error => {
          console.log(error);
        });
  }


  showAdditionalItemsLink(): boolean {
    return this.applicationsDD.length > 0;
  }

  activateLink(quickLink: ApplicationItem) {
    if (quickLink != undefined) {
      if (quickLink.routerLink) {
        this.router.navigate([quickLink.routerLink], { relativeTo: this.route });
      } else {
        window.open(quickLink.actionUrl, quickLink.target, 'noreferrer')
      }
    }
  }
  imageClick(event: any) {
    this.singleaAplication = this.actualapplications.filter(x => x.text == event.target.alt)[0];
    this.activateLink(this.singleaAplication);
  }

  getPinnedData() {
    zip(this.appService.getAllItems(), this.tiliesService.getPinnedTiles())

      .subscribe(([dataApps, dataPin]) => {
        this.appsItem = dataApps;
        this.loadAppsItems();

        var allApplications = this.getTiles();

        allApplications.forEach((tile) => {
          if (this.featureaccess.getAccessPermission(`/App-${tile.data.text}`)) {
            this.tilesApplications.push(tile);
          }
          else if (this.tilesApplications.length == 0) {
            this.tilesApplications = this.getTiles();
          }
        })
        this.pinnedTiles = dataPin;
        dataPin.forEach((tile: any, index: number) => {
          if (this.tilesApplications.filter(x => x.data.tile.id == tile.tileId).length > 0) {
            this.tiles.push(this.tilesApplications.filter(x => x.data.tile.id == tile.tileId)[0]);
          }
        });
        this.loadFilterAppsItems();
        this.loadItems()
      })
  }
  loadAppsItems(): void {
    this.appsItem.forEach((app) => {
      app.tile = {
        color: "secondary2",
        type: "application",
        title: "Applications",
        size: "xlarge",
        id: app.id!,
        cssclass: "tilebutton",
        ispinned: true
      };
    });
  }
  loadFilterAppsItems(): void {
    this.appsItem.forEach((app) => {
      this.tiles.forEach((tile) => {
        if (app.tile.id == tile.id) {
          this.actualapplications.push(app);
        }
      });
    });
  }
  getTiles(): Tile[] {
    return this.appsItem.map((application) => {
      var tile = application.tile;
      tile.data = application;
      return tile;
    });
  }
  private loadItems(): void {
    this.actualapplications.forEach((apps) => {
      this.imageObject = {
        image: apps.imageUrl,
        thumbImage: apps.imageUrl,
        alt: apps.text,
        routerLink: apps.routerLink
      }
      this.imageObjects.push(this.imageObject);
    });
  }
}
export interface ImageObject {
  image: string;
  thumbImage: string;
  alt: string;
  routerLink: string;
}

